import api from './api';

const moderationService = {
  // Get moderation statistics
  getStats: async () => {
    const response = await api.get('/admin/moderation/stats/');
    return response.data;
  },

  // Get moderation queue
  getQueue: async (params = {}) => {
    const response = await api.get('/admin/moderation/queue/', { params });
    return response.data;
  },

  // Get all moderations with filters
  getModerations: async (params = {}) => {
    const response = await api.get('/admin/moderation/', { params });
    return response.data;
  },

  // Get single moderation
  getModeration: async (id) => {
    const response = await api.get(`/admin/moderation/${id}/`);
    return response.data;
  },

  // Approve product
  approveProduct: async (id, reason = 'Approved by admin') => {
    const response = await api.post(`/admin/moderation/${id}/approve/`, { reason });
    return response.data;
  },

  // Reject product
  rejectProduct: async (id, reason) => {
    if (!reason) {
      throw new Error('Rejection reason is required');
    }
    const response = await api.post(`/admin/moderation/${id}/reject/`, { reason });
    return response.data;
  },

  // Reset to pending
  resetToPending: async (id) => {
    const response = await api.post(`/admin/moderation/${id}/reset/`);
    return response.data;
  },

  // Assignment system methods
  
  // Assign product to current admin
  assignToMe: async (id, lockDurationMinutes = null) => {
    const payload = {};
    if (lockDurationMinutes) {
      payload.lock_duration_minutes = lockDurationMinutes;
    }
    const response = await api.post(`/admin/moderation/${id}/assign/`, payload);
    return response.data;
  },

  // Release assignment
  releaseAssignment: async (id) => {
    const response = await api.post(`/admin/moderation/${id}/release/`);
    return response.data;
  },

  // Get my assignments
  getMyAssignments: async (params = {}) => {
    const response = await api.get('/admin/moderation/my-assignments/', { params });
    return response.data;
  },

  // Release expired locks (admin only)
  releaseExpiredLocks: async () => {
    const response = await api.post('/admin/moderation/release-expired/');
    return response.data;
  },

  // Debug assignments (for troubleshooting)
  debugAssignments: async () => {
    const response = await api.get('/admin/moderation/debug-assignments/');
    return response.data;
  },

  // ML Model Management
  overrideAIDecision: async (id, adminDecision, reason = '') => {
    const response = await api.post(`/admin/moderation/${id}/override-ai/`, {
      admin_decision: adminDecision,
      reason: reason
    });
    return response.data;
  },

  trainMLModel: async () => {
    const response = await api.post('/admin/moderation/train-ml-model/');
    return response.data;
  },

  getMLModelInfo: async () => {
    const response = await api.get('/admin/moderation/ml-model-info/');
    return response.data;
  },
};

export default moderationService;

